import React from "react";
import { Col } from "react-bootstrap";
import { FlexRow, FlexColumn } from "../../common/CommonStyles";
import { NavContext } from "../../common/context/NavContext";
import { useHistory, Link } from "react-router-dom";
import { TabEnum } from "../../common/context/TabsContext";
import { useTranslation } from "react-i18next";

const CancelButton = ({ onCancel }: { onCancel?: () => void }) => {
  const { goBack, hasBack, resetNavigationBoundary } =
    React.useContext(NavContext);
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <Link
      to=""
      onClick={(event) => {
        if (onCancel) {
          onCancel();
        } else if (hasBack()) {
          goBack();
        } else {
          history.push(TabEnum.MyClass);
          resetNavigationBoundary();
        }
        event.preventDefault();
      }}
      style={{ textDecoration: "none" }}
    >
      <span>{t("generic_cancel")}</span>
    </Link>
  );
};

export const StepNavHeader = ({
  isReplaceBackWithCancel,
  onBack,
  onCancel,
  header,
  isNextVisible,
  isNextEnabled,
  onNext,
}: {
  isReplaceBackWithCancel: boolean;
  isNextVisible: boolean;
  isNextEnabled: boolean;
  header: string;
  onBack: () => void;
  onCancel?: () => void;
  onNext: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <FlexRow className="align-items-center my-3">
      <FlexColumn style={{ justifyContent: "left" }}>
        {isReplaceBackWithCancel ? (
          <CancelButton onCancel={onCancel} />
        ) : (
          <Link
            to=""
            onClick={(event) => {
              onBack();
              event.preventDefault();
            }}
            style={{ textDecoration: "none" }}
          >
            {t("generic_nav_back")}
          </Link>
        )}
      </FlexColumn>
      <Col>
        <h4 className="text-center">{header}</h4>
      </Col>
      <FlexColumn style={{ justifyContent: "right" }}>
        {isNextVisible && isNextEnabled && (
          <Link
            to=""
            onClick={(event) => {
              onNext();
              event.preventDefault();
            }}
            enabled={"false"}
            style={{ textDecoration: "none" }}
          >
            {t("generic_nav_next")}
          </Link>
        )}
        {isNextVisible && !isNextEnabled && (
          <span>{t("generic_nav_next")}</span>
        )}
        {!isNextVisible && <></>}
      </FlexColumn>{" "}
    </FlexRow>
  );
};
